import {Parser} from './parser';

export class Trader {
  id: number;
  name: string;
  rating: number;
  parser: Parser;
}
